export const ADMIN_GROUP_NAME = 'ADMIN';

export enum FEATURE_FLAGS {
  ALL = 'All',
  USER_MGMT_ENABLED = 'isUserMgmtEnabled',
  SHOW_USRTBL_HIDDEN_COLS = 'showUserTblHiddenColumns',
  WORK_ORDER_ENABLED = 'isViewWorkorderEnabled',
  IS_DUAL_WRITE_ENABLED = 'isDualWriteEnabled',
  WORK_ORDER_EDIT_ENABLED = 'isEditWorkOrderEnabled',
  CREATE_WORK_ORDER_ENABLED = 'isCreateWorkOrderEnabled',
  DELETE_WORK_ORDER_ENABLED = 'isDeleteWorkOrderEnabled',
  HUB_LOGS_ENABLED = 'isHubLogsEnabled',
  POS_INTERFACE_ENABLED = 'isPosInterfaceEnabled',
  MANUAL_RELEASED_ENABLED = 'isManualReleasedEnabled',
  AUDIT_TRAIL_ENABLED = 'isAuditTrailEnabled',
  CASING_HISTORY_ENABLED = 'isCasingHistoryEnabled',
  RS_CASING_TRANSFER_ENABLED = 'isRSCasingTransferEnabled',
  AUDIT_LOGS_SCREEN_ENABLED = 'isAuditLogsScreenEnabled',
  USER_MANUAL_ENABLED = 'isUserManualEnabled',
  /**
   * Generic gate for features that are merged but not yet released to all dealers.
   * Intentionally NOT feature-specific so it can be reused by upcoming work;
   * remove the flag usage (not the enum) once a feature goes GA.
   */
  EARLY_ACCESS_ENABLED = 'isEarlyAccessEnabled',
  NOTIFICATIONS_ENABLED = 'isNotificationsEnabled',
  BANNERS_ENABLED = 'isBannersEnabled',
  LEGACY_NAFA_CAM_SPEC_NOTIFICATIONS_ENABLED = 'nafaCamSpecNotificationsEnabled',
  CAM_SPEC_NOTIFICATIONS_ENABLED = 'camSpecNotificationsEnabled',
  /** When off, Casing Search Tread, Tread Width and Grade stay single-select (BTN-18347). */
  MULTI_SELECT_TREAD_WIDTH_GRADE_ENABLED = 'isMultiSelectTreadWidthGradeEnabled'
}
